<div class="email-invite-container">
  <img src="/assets/images/time-out.png" alt="Timeout Image" />
  <div class="invite-alert">Welcome to Developer Console</div>
  <div class="invite-description">Please log in to join {{ member_type }} of {{ project.project_name }}</div>
  <a href="{{ loginLink }}">
    <div class="center">
      <sdc-design-button
        type="primary"
        [title]="'Sign in'"
        width="220px"
        height="40px"
        [routerLink]="loginLink"
      ></sdc-design-button>
    </div>
  </a>
</div>
